import { ToolBarItemViewModel } from '#/DefaultViewExtensionInterfaces';
import ToolBarViewModelType from '@/ViewModels/Controls/ToolBarViewModel';
import Constants from '@/AppConstants';

export default class ToolbarHelper {

    public static removeSaveButton(toolbar: ToolBarViewModelType, notify: boolean = true) {
        ToolbarHelper.removePrimaryLink(toolbar, Constants.TOOLBAR_SAVE_BUTTON, notify);
    }

    public static removeApplyButton(toolbar: ToolBarViewModelType, notify: boolean = true) {
        ToolbarHelper.removePrimaryLink(toolbar, Constants.TOOLBAR_APPLY_BUTTON, notify);
    }

    public static removeCancelButton(toolbar: ToolBarViewModelType, notify: boolean = true) {
        ToolbarHelper.removePrimaryLink(toolbar, Constants.TOOLBAR_CANCEL_BUTTON, notify);
    }

    private static removePrimaryLink(toolbar: ToolBarViewModelType, technicalName: string, notify: boolean) {
        const primary = toolbar.primary()
        const indexToRemove = primary.findIndex(item => item.technicalName === technicalName);

        ToolbarHelper.removeButton(primary, indexToRemove);

        if (notify)
            toolbar.primary.notifySubscribers(toolbar.primary());
    }

    private static removeButton(links: Array<ToolBarItemViewModel>, indexToRemove: number) {
        if (indexToRemove === -1)
            return;

        links.splice(indexToRemove, 1);
    }
}